'use strict';

import Loader from '../loader/loader';
import UpdateAccount from '../update-account/update-account';
import StaffShopUpdateAccount from '../staffshop-users/update-account';
import DataTable from 'dataTable';
import { toaster } from '../../_assets/abbott/js/_material';

//DataTables plugins that allows sorting with any date format
(function (factory) {
    if (typeof define === "function" && define.amd) {
        define(["jquery", "moment", "datatables.net"], factory);
    } else {
        factory(jQuery, moment);
    }
}(function ($, moment) {

    $.fn.dataTable.moment = function ( format, locale ) {
        var types = $.fn.dataTable.ext.type;

        // Add type detection
        types.detect.unshift( function ( d ) {
            if ( d ) {
                // Strip HTML tags and newline characters if possible
                if ( d.replace ) {
                    d = d.replace(/(<.*?>)|(\r?\n|\r)/g, '');
                }

                // Strip out surrounding white space
                d = $.trim( d );
            }

            // Null and empty values are acceptable
            if ( d === '' || d === null ) {
                return 'moment-'+format;
            }

            return moment( d, format, locale, true ).isValid() ?
                'moment-'+format :
                null;
        } );

        // Add sorting method - use an integer for the sorting
        types.order[ 'moment-'+format+'-pre' ] = function ( d ) {
            if ( d ) {
                // Strip HTML tags and newline characters if possible
                if ( d.replace ) {
                    d = d.replace(/(<.*?>)|(\r?\n|\r)/g, '');
                }

                // Strip out surrounding white space
                d = $.trim( d );
            }

            return d === '' || d === null ?
                -Infinity :
                parseInt( moment( d, format, locale, true ).format( 'x' ), 10 );
        };
    };

}));


//Deal with tables using dataTable plugin
export default class TableSort {
    constructor() {
        let isAllClients = false,
            onlyActiveClients = false,
            $regimenStatusTable = $('#table-regimen-status'),
            $productsTable = $('#table-products');

        /** needed to call regimenlistings API, but with different parameters according to the page
         / if dashboard -> display only clients with regimen
         / if client-managemnt --> display all the clients
         **/
        if($('.patient-management').length){
            isAllClients = true;
        }

        // Disable DataTable error alert
        $.fn.dataTable.ext.errMode = 'none';

        //Allow sorting with date format 'DD-MM-YYYY'
        $.fn.dataTable.moment( 'DD-MM-YYYY' );
        $.fn.dataTable.moment( 'DD-MM-YYYY HH:mm' );
        $.fn.dataTable.moment( 'DD-MM-YYYY HH:mm:ss A' );

        // Redirect to given url if row is clickable
        $('.row--clickable').delegate('tbody tr','click', function (e) {
            let $url = $(this).data('url');
            window.location = $url;
        });


        //Tables: Regimen status displayed on dahsboard page
        // Client Management displayed on client management page
        if ($regimenStatusTable.length){

            let $userFilter = $('#FilterByUser li'),
                $statusFilter = $('#FilterByStatus li'),
                $institutionFilter = $('#filterByInstitution'),
                $deactivatedClientsFilter = $('#onlyActive'),
                $archivedClientsFilter = $('#showArchived'),
                urlNoQuery = '/api/clientlistings?includeAllClients='+isAllClients,
                apiUrl = urlNoQuery,
                userQuery = true,
                statusQuery = '',
                table = '';

            //Define table structure
            let initTable = function(){
                table = $('#table-regimen-status').
                on( 'error.dt', function ( e, settings, techNote, message ) {
                    console.log( 'An error has been reported by DataTables: ', message );
                } ).
                DataTable({
                    autoWidth: false,
                    processing: true,
                    serverSide: true,
                    retrieve: true,
                    ajax: {
                        url: apiUrl,
                        type: "GET"
                    },
                    dom: '<"">frtip',
                    order: [[ 4, 'desc' ]],
                    columns: [
                        { 'data': 'clientUr', 'orderable': false, render: $.fn.dataTable.render.text() },
                        { 'data': 'clientName', 'orderable': true, render: $.fn.dataTable.render.text() },
                        { 'data': 'hensId', 'orderable': false, render: $.fn.dataTable.render.text() },
                        { 'data': 'hcpName', 'orderable': false, render: $.fn.dataTable.render.text() },
                        { 'data': 'regimenExpiry', 'orderable': true, render: $.fn.dataTable.render.text() },
                        { 'data': 'orderStatus.status', 'orderable': true, render: $.fn.dataTable.render.text() },
                        { 'data': 'dateCreated', 'orderable': false, render: $.fn.dataTable.render.text() }
                    ],
                    createdRow : function(row, data, dataIndex){

                        //set url for clickable row
                        var url = data.url;
                        $(row).attr('data-url', url );

                        // set additional markup to display regime status
                        if($(window).width()>767){
                            $('td', row).eq(5).prepend('<span class= "status status--'+ data.orderStatus.color + '"></span>');
                        }
                        else{
                            $('td', row).eq(4).prepend('<span class= "status status--'+ data.orderStatus.color + '"></span>');
                        }
                    },
                    initComplete: function () {
                        this.api().columns().every( function () {
                            var column = this;
                        });
                    }
                });
            };

            //Draw new table after filtering
            let drawTable = function(){

                table.destroy();
                initTable();
            };

            //Initialize table oh page load
            initTable();

            //customer service can filter by institution
            $('body').on('click', '.js-filter-institution', function (e){
                e.preventDefault();

                let url = urlNoQuery,
                    institutionQuery = $(this).data('index'),
                    institutionName = $(this).data('name'),
                    $suggestions = $(this).closest('.form--suggestions-institutions'),
                    statusQuery;

                apiUrl = filterByStatus(url) + '&institutionId=' + institutionQuery;

                $institutionFilter.val(institutionName);
                $institutionFilter.attr('data-index', institutionQuery);
                $suggestions.removeClass('active');

                drawTable();

            });

            //customer service can filter by institution
            $institutionFilter.on('change', function (e){
                e.preventDefault();

                if($institutionFilter.val() != ''){
                    return false;
                }

                //resolve this url for 'all' after an institution is selected and then removed
                let url = urlNoQuery;

                $(this).attr('data-index', '');

                apiUrl = filterByStatus(url);

                drawTable();

            });

            $userFilter.on('click', function(e){
                e.preventDefault();

                let url = urlNoQuery;

                if($(this).hasClass('mine')){
                    userQuery = false;
                }
                else{
                    userQuery = true;
                }


                apiUrl = filterByStatus(url)  + '&all=' + userQuery;

                drawTable();

            });

            $statusFilter.on('click', function(e){
                e.preventDefault();

                let query = $(this).attr('data-value'),
                    url = urlNoQuery,
                    institutionId = '';

                if($('.customer-service').length){

                    institutionId = $institutionFilter.attr('data-index');
                    url = url + '&institutionId' + institutionId;
                }

                apiUrl = url + '&orderStatus=' + query;

                drawTable(apiUrl);
            });

            $deactivatedClientsFilter.click(function(){
              if ($('#onlyActive').is(':checked')) {
                    $regimenStatusTable.attr('data-onlyActiveClients', false);
                }else
                {
                    $regimenStatusTable.attr('data-onlyActiveClients', true);
                }

                let url = urlNoQuery;

                apiUrl = url +'&onlyActiveClients='+ $regimenStatusTable.attr('data-onlyActiveClients');
                drawTable();
            });

            $archivedClientsFilter.click(function(){
              if ($('#showArchived').is(':checked')) {
                  $regimenStatusTable.attr('data-showArchivedClients', true);
              }else
              {
                  $regimenStatusTable.attr('data-showArchivedClients', false);
              }

              let url = urlNoQuery;

              apiUrl = url +'&showArchivedClients='+ $regimenStatusTable.attr('data-showArchivedClients');
              drawTable();
            });

        }

        if($productsTable.length){

            let $brandFilter = $('#FilterByBrand li'),
                urlNoQuery = "/api/productlistings",
                apiUrl = urlNoQuery,
                brandQuery = '',
                table = '',
                $archivedProductsFilter = $('#showArchivedProducts');



                let initTable = function(){
                table = $productsTable.
                        on( 'error.dt', function ( e, settings, techNote, message ) {
                            console.log( 'An error has been reported by DataTables: ', message );
                        } ).
                        DataTable({
                            autoWidth: false,
                            processing: true,
                            serverSide: false,
                            retrieve: true,
                            ajax: {
                                url: apiUrl,
                                type: "GET"
                            },
                            dom: '<"">frtip',
                            order: [[ 1, 'desc' ]],
                            columns: [
                                { 'data': 'sku', 'orderable': false, render: $.fn.dataTable.render.text() },
                                { 'data': 'description', 'orderable': true, render: $.fn.dataTable.render.text() },
                                { 'data': 'basePrice', 'orderable': true, render: $.fn.dataTable.render.text() },
                                { 'data': 'status', 'orderable': false, render: $.fn.dataTable.render.text() },
                                { 'data': 'sydneyStock', 'orderable': false, render: $.fn.dataTable.render.text() },
                                { 'data': 'melbourneStock', 'orderable': false, render: $.fn.dataTable.render.text() },
                                { 'data': 'perthStock', 'orderable': false, render: $.fn.dataTable.render.text() },
                                { 'data': 'adelaideStock', 'orderable': false, render: $.fn.dataTable.render.text() },
                                { 'data': 'specialSydneyStock', 'orderable': false, render: $.fn.dataTable.render.text() },
                                { 'data': 'specialMelbourneStock', 'orderable': false, render: $.fn.dataTable.render.text() },
                                { 'data': 'specialPerthStock', 'orderable': false, render: $.fn.dataTable.render.text() },
                                { 'data': 'specialAdelaideStock', 'orderable': false, render: $.fn.dataTable.render.text() }
                            ],
                            createdRow : function(row, data, dataIndex){
                              //set url for clickable row
                              var url = data.url;
                              $(row).attr('data-url', url );
                            },
                            initComplete: function () {
                                this.api().columns().every( function () {
                                    var column = this;
                                });
                            }
                        });
                    };


            // Draw new table after filtering
            let drawTable = function(){

                table.destroy();
                initTable();
            };

            //Initialize table oh page load
            initTable();

            //filtering table by brand
            $brandFilter.on('click', function(e){
                e.preventDefault();

                let query = $(this).attr('data-value'),
                    url = urlNoQuery,
                    brandId = '';

                if($('.customer-service').length){

                    brandId = $institutionFilter.attr('data-index');
                    url = url + '&institutionId' + brandId;
                }

                apiUrl = url + '&productBrand=' + query;

                drawTable(apiUrl);
            });

            $archivedProductsFilter.on("change", function(e){
                console.log("Show archived proucts clicked");
                if($(this).prop("checked")) {
                    apiUrl = `${urlNoQuery}?ShowArchivedProducts=true`;
                } else {
                    apiUrl = urlNoQuery;
                }
                drawTable(apiUrl);
            });
        }


        //Table: Regimen on edit-patient page
        if($('#table-regimen').length){
            $('#table-regimen').DataTable({
                dom: '<"">frtip',
                order: [[ 1, 'desc' ]],
                columns: [
                    { "orderable": false },
                    null,
                    null,
                    null,
                    { "orderable": false },
                    null
                ],
                initComplete: function () {
                    this.api().columns().every( function () {
                        var column = this;
                    });

                    $('.buttons-filter').on('click', '.buttons-filter--btn', function (e) {
                        e.preventDefault();

                        var $current = $('.dataTables_filter input').val();

                        var $this = $(this),
                            $val = $this.text().toLowerCase(),
                            hpcId = $this.data('id');

                        if ($val == 'all') {
                            $val = '';
                        }
                        else{
                            $val = hpcId;
                        }

                        //$('.dataTables_filter input').val($val).trigger('keyup');

                        // adds keyword and menu selection
                        $val = $val + ' ' + $current;
                        // search by filter and keyword
                        $('.dataTables_filter input').val($val).trigger('keyup');
                        // show only keyword
                        $('.dataTables_filter input').val($current);
                    });
                }
            });
        }

        //Table: Orders for regimen on view-regimen page
        if($('#table-regimen--orders').length){
            $('#table-regimen--orders').DataTable({
                dom: '<"">frtip',
                order: [[ 1, 'desc' ]],
                columns: [
                    { "orderable": false },
                    null,
                    null,
                    null,
                    { "orderable": false },
                    null
                ],
                initComplete: function () {
                    this.api().columns().every( function () {
                        var column = this;
                    });

                    $('.filter-dropdown').on('click', '.filter-dropdown--item', function (e) {
                        e.preventDefault();

                        // store text from search box
                        var $current = $('.dataTables_filter input').val();

                        var $this = $(this),
                            $val = $this.text().toLowerCase();

                        $('.filter-dropdown').find('.active').removeClass('active');
                        $this.addClass('active');


                        if ($val == 'all') {
                            $val = '';
                        }

                        //$('.dataTables_filter input').val($val).trigger('keyup');

                        // adds keyword and menu selection
                        $val = $val + ' ' + $current;
                        // search by filter and keyword
                        $('.dataTables_filter input').val($val).trigger('keyup');
                        // show only keyword
                        $('.dataTables_filter input').val($current);
                    });
                }
            });
        }

        //Table: Orders for regimen on view-regimen page
        if($('#table-abbott-admin--orders').length){
            $('#table-abbott-admin--orders').DataTable({
                dom: '<"">frtip',
                order: [[ 1, 'desc' ]],
                columns: [
                    { "orderable": false },
                    null,
                    null,
                    null,
                    { "orderable": false },
                    null,
                    null,
                    null
                ],
                initComplete: function () {
                    this.api().columns().every( function () {
                        var column = this;
                    });
                }
            });
        }

        //Table: HCP Management displayed on hcp-manage page
        if($('#table-hcp').length){
            let $institutionId = $('#institutionId'),
                $statusFilter = $('#FilterByStatus button'),
                urlNoQuery = '/api/hcpworkplacelistings?institutionId=' + $institutionId.val(),
                table = '',
                apiUrl = urlNoQuery;

            let initTable = function(){

                table= $('#table-hcp').
                on( 'error.dt', function ( e, settings, techNote, message ) {
                    console.log( 'An error has been reported by DataTables: ', message );
                } ).
                DataTable({
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: apiUrl,
                        type: 'GET'
                    },
                    dom: '<"">frtip',
                    order: [[ 0, 'asc' ]],
                    columns: [
                        { 'data': 'name', 'orderable': true, render: $.fn.dataTable.render.text() },
                        { 'data': 'phoneNumber', 'orderable': false, render: $.fn.dataTable.render.text() },
                        { 'data': 'lastLogin', 'orderable': true, render: $.fn.dataTable.render.text() },
                        { 'data': 'isManager', 'orderable': true, render: $.fn.dataTable.render.text()},
                        { 'data': 'status.status', 'orderable': true, render: $.fn.dataTable.render.text()},
                    ],
                    createdRow : function(row, data, dataIndex){

                        //set url for clickable row
                        var url = data.url;
                        $(row).attr('data-url', url );

                        // set additional markup to display hcp status
                        if($(window).width()>767){
                            $('td', row).eq(4).prepend('<span class= "status status--'+ data.status.color + '"></span>');
                        }
                        else{
                            $('td', row).eq(1).prepend('<span class= "status status--'+ data.status.color + '"></span>');
                        }
                    },
                    initComplete: function () {
                        this.api().columns().every( function () {
                            var column = this;
                        });
                    }
                });

            }

            let drawTable = function(){

                table.destroy();
                initTable();
            };

            //Initialize table on page load
            initTable();

            $statusFilter.on('click', function(e){
                e.preventDefault();

                let query = $(this).attr('data-value'),
                    url = urlNoQuery;
                //institutionId = '';

                apiUrl = url + '&status=' + query;

                drawTable();
            });

        }


        //Table: Abbott Admin Management displayed on admin-dashboard page
        if($('#table-sort-admin').length){
            $('#table-sort-admin').
            on( 'error.dt', function ( e, settings, techNote, message ) {
                console.log( 'An error has been reported by DataTables: ', message );
            } ).
            DataTable({
                processing: true,
                serverSide: true,
                retrie : true,
                ajax: {
                    url: '/api/abbottadminlistings',
                    type: 'GET'
                },
                order: [[ 0, 'asc' ]],
                dom: '<"">frtip',
                columns: [
                    { 'data': 'adminName', 'orderable': true, render: $.fn.dataTable.render.text() },
                    { 'data': 'role', 'orderable': true, render: $.fn.dataTable.render.text() },
                    { 'data': 'lastLogin', 'orderable': true, render: $.fn.dataTable.render.text() },
                    { 'data': 'region', 'orderable': true, render: $.fn.dataTable.render.text() },
                    { 'data': 'status', 'orderable': true, render: $.fn.dataTable.render.text() }
                ],
                createdRow : function(row, data, dataIndex){

                    //set admin id
                    var id = data.adminId;
                    $(row).attr('data-id', id );

                    // $(row).addClass('list');
                }
            });
        }


        $('#table-sort-admin tbody').delegate('tr','click', function (e) {
            e.preventDefault();
            let loader = new Loader(),
                updateAccount = new UpdateAccount();

            let id = $(this).data('id'),
                dataParams = {
                    "id": id
                };

            loader.fadeIn();

            $.ajax({
                url: '/api/getabbottadmin/' + id,
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                type: 'GET',
                //data: JSON.stringify(dataParams),
                success: function (data) {
                    loader.fadeOut();

                    $('body').addClass('fixed');

                    $('.update-account__dropdown').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                    updateAccount.populateOverlay(data, id);
                },
                error: function (error) {
                    loader.fadeOut();
                    toaster('Oops! Something went wrong! Error (' + error.status + ' ' + error.statusText + ')');
                }
            });
        });

        //Table: Staff Shop Management displayed on staffshop-dashboard page
        if($('#table-sort-ssu').length){
            $('#table-sort-ssu').
            on( 'error.dt', function ( e, settings, techNote, message ) {
                console.log( 'An error has been reported by DataTables: ', message );
            } ).
            DataTable({
                processing: true,
                serverSide: true,
                retrie : true,
                ajax: {
                    url: '/api/staffshopuserlistings',
                    type: 'GET'
                },
                order: [[ 2, 'desc' ]],
                dom: '<"">frtip',
                columns: [
                    { 'data': 'staffName', 'orderable': true, render: $.fn.dataTable.render.text() },
                    { 'data': 'email', 'orderable': true, render: $.fn.dataTable.render.text() },
                    { 'data': 'lastLogin', 'orderable': true, render: $.fn.dataTable.render.text() },
                    { 'data': 'companyName', 'orderable': true, render: $.fn.dataTable.render.text() },
                    { 'data': 'status', 'orderable': true, render: $.fn.dataTable.render.text() }
                ],
                createdRow : function(row, data, dataIndex){

                    //set admin id
                    var id = data.staffShopUserId;
                    $(row).attr('data-id', id );

                    // $(row).addClass('list');
                }
            });
        }

        $('#table-sort-ssu tbody').delegate('tr','click', function (e) {
            e.preventDefault();
            return;
            let loader = new Loader(),
                updateAccount = new StaffShopUpdateAccount();

            let id = $(this).data('id'),
                dataParams = {
                    "id": id
                };

            loader.fadeIn();

            $.ajax({
                url: '/api/getstaffshopuser/' + id,
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                type: 'GET',
                //data: JSON.stringify(dataParams),
                success: function (data) {
                    loader.fadeOut();

                    $('body').addClass('fixed');

                    $('.update-account__dropdown').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                    updateAccount.populateOverlay(data, id);
                },
                error: function (error) {
                    loader.fadeOut();
                    toaster('Oops! Something went wrong! Error (' + error.status + ' ' + error.statusText + ')');
                }
            });
        });


        //Table: Institutions management on institution-management page
        if ($('#table-sort-institution').length) {

            $('#table-sort-institution').DataTable({
                processing: true,
                serverSide: true,
                ajax: {
                    url: '/api/institutions/institutionlistings',
                    type: 'GET'
                },
                dom: '<"">frtip',
                order: [[ 1, 'asc' ]],
                columns: [
                    { 'data': 'id', 'orderable': false, render: $.fn.dataTable.render.text() },
                    { 'data': 'name' , 'orderable': true, render: $.fn.dataTable.render.text() },
                    { 'data': 'region' , 'orderable': true, render: $.fn.dataTable.render.text() },
                    { 'data': 'status' , 'orderable': true, render: $.fn.dataTable.render.text() },
                    { 'data': 'tenderId', 'orderable': false, render: $.fn.dataTable.render.text() }
                ],
                createdRow : function(row, data, dataIndex){

                    //set url for clickable row
                    var url = data.url;
                    $(row).attr('data-url', url );
                },
                initComplete: function () {
                    this.api().columns().every( function () {
                        var column = this;
                    });
                }
            });
        }


        //Table: Tender management on tenders page
        if($('#table-sort-tender').length){
            $('#table-sort-tender').DataTable({
                processing: true,
                serverSide: true,
                ajax: {
                    url: '/api/tenders',
                    type: 'GET'
                },
                dom: '<"">frtip',
                order: [[ 1, 'asc' ]],
                columns: [
                    { 'data': 'id', 'orderable': false, render: $.fn.dataTable.render.text() },
                    { 'data': 'name', 'orderable': false, render: $.fn.dataTable.render.text() },
                    { 'data': 'deliveryCostType', 'orderable': false, render: $.fn.dataTable.render.text() },
                    { 'data': 'quantityType', 'orderable': false, render: $.fn.dataTable.render.text() },
                ],
                createdRow : function(row, data, dataIndex){

                    //set url for clickable row
                    var url = data.url;
                    $(row).attr('data-url', url );
                },
                initComplete: function () {
                    this.api().columns().every( function () {
                        var column = this;
                    });
                }
            });
        }


        //Table: HCP / HDM on hcp-hdm page
        if ($('#table-sort-hcphdm').length) {

            let $statusFilter = $('#FilterByStatus li'),
                $institutionFilter = $('#filterByInstitution'),
                urlNoQuery = '/api/hcplistings?',
                apiUrl = urlNoQuery,
                table = '';

            //filter by Institution Name on page load, if input is prepopulated
            if($institutionFilter.val() !== '')
                apiUrl += '&institution=' + $institutionFilter.val();

            //Define table structure
            let initTable = function(){
                table = $('#table-sort-hcphdm').
                on( 'error.dt', function ( e, settings, techNote, message ) {
                    console.log( 'An error has been reported by DataTables: ', message );
                } ).
                DataTable({
                    autoWidth: false,
                    processing: true,
                    serverSide: true,
                    retrieve: true,
                    ajax: {
                        url: apiUrl,
                        type: "GET"
                    },
                    dom: '<"">frtip',
                    order: [[4, 'asc']],
                    columns: [
                        { 'data': 'name', "orderable": true, render: $.fn.dataTable.render.text() },
                        { 'data': 'mobileNumber', "orderable": false, render: $.fn.dataTable.render.text() },
                        { 'data': 'institutions', "orderable": true,render: $.fn.dataTable.render.text() },
                        { 'data': 'state', "orderable": true, render: $.fn.dataTable.render.text()},
                        { 'data': 'lastLogin', "orderable": true, render: $.fn.dataTable.render.text()},
                        { 'data': 'status', "orderable": true, render: $.fn.dataTable.render.text() }
                    ],
                    createdRow : function(row, data, dataIndex){

                        //set url for clickable row
                        var url = data.url;
                        $(row).attr('data-url', url );
                    },
                    initComplete: function () {
                        this.api().columns().every( function () {
                            var column = this;
                        });
                    }
                });
            };

            //Draw new table after filtering
            let drawTable = function(){

                table.destroy();
                initTable();
            };

            //Initialize table oh page load
            initTable();

            $('body').on('click', '.js-filter-institution', function (e){
                e.preventDefault();

                let url = urlNoQuery,
                    institutionQuery = $(this).data('index'),
                    institutionName = $(this).data('name'),
                    $suggestions = $(this).closest('.form--suggestions-institutions'),
                    statusQuery;

                apiUrl = filterByStatus(url) + '&institution=' + institutionName;

                $institutionFilter.val(institutionName);
                $institutionFilter.attr('data-index', institutionQuery);
                $suggestions.removeClass('active');

                drawTable();

            });

            $institutionFilter.on('change', function (e){
                e.preventDefault();

                if($institutionFilter.val() != ''){
                    return false;
                }

                let url = urlNoQuery;

                $(this).attr('data-index', '');

                apiUrl = filterByStatus(url);

                drawTable();

            });

            $statusFilter.on('click', function(e){
                e.preventDefault();

                let query = $(this).data('value'),
                    url = urlNoQuery,
                    institutionId = '';

                if($('.customer-service').length){

                    institutionId = $institutionFilter.data('index');
                    url += url + '&institutionId' + institutionId;
                }

                apiUrl = url + '&status=' + query;

                drawTable(apiUrl);
            });
        }


        //Table: tender institutions on view-tender page
        if($('#table-tender-institutions').length){
            $('#table-tender-institutions').DataTable({
                ordering: false,
                pageLength: 20
            });
        }

        //Table: tender products on view-tender page
        if($('#table-tender-products').length){
            $('#table-tender-products').DataTable({
                ordering: true,
                pageLength: 20,
                order: [[0, 'desc']],
                columns: [
                    // {"name": "Id", visible: false},
                    {"name": "Sku", visible: true},
                    {"name": "Product", orderable: false},
                    // {"name": "BasePrice", orderable: false},
                    {"name": "TenderPrice", orderable: false},
                    {"name": "Under42Price", orderable: false},
                    {"name": "SingleUnitPrice", orderable: false},
                    {"name": "StartDate", orderable: false},
                    {"name": "ExpiryDate", orderable: false}
                ],
                columnDefs: [
                    { targets: [0], orderSequence: ["desc"]}
                ]
            });
        }

        if($('#table-sort-content').length > 0){
            $('#table-sort-content').
            on( 'error.dt', function ( e, settings, techNote, message ) {
                console.log( 'An error has been reported by DataTables: ', message );
            } ).
            DataTable({
                dom: '<"">frtip',
                order: [[2, 'desc']],
            });
        }


        let filterByStatus = function(url){

            if($('#FilterByStatus .filter-dropdown--selected').hasClass('selected')){

                let statusFilter = $('#FilterByStatus .filter-dropdown--selected'),
                    statusQuery = statusFilter.attr('data-value');

                url += '&status=' + statusQuery;
            }

            return url;
        }

    }
}
